import { RunnableReportConfiguration } from "./runnable_report";

export interface PublicApiReport {
    _id: string;
    _rev: string;
    type: string;
    version: number;
    versionGroupId: string;
    state: string;
    organisation: string;
    name: string;
    description: string;
    run_by_roles: string[];
    roles: string[];
    relations: string[];
    createdDate: string;
    modifiedDate: string;
    report: RunnableReportConfiguration;
}

export function isPublicApiReport(data: any): data is PublicApiReport {
    return data && data.type === 'report' ;
}


export interface ReportApiMetadata {
    can_navigate_to: boolean;
}

export interface ReportMetadata {
    canNavigateTo: boolean;
}

export class Report {
    id: string;
    rev: string;
    type: string;
    version: number;
    versionGroupId: string;
    state: string;
    organisation: string;
    name: string;
    description: string;
    run_by_roles: string[];
    roles: string[];
    relations: string[];
    createdDate: string;
    modifiedDate: string;
    report: RunnableReportConfiguration;

    constructor(data: Partial<Report> = {}) {
        Object.assign(this, data);
    }

    // Deserialize from API response
    static fromApiResponse(response: PublicApiReport): Report {
        if (!isPublicApiReport(response)) {
            throw new Error('Invalid report API response');
        }

        return new Report({
            id: response._id,
            rev: response._rev,
            type: response.type,
            version: response.version,
            versionGroupId: response.versionGroupId,
            state: response.state,
            name: response.name,
            organisation: response.organisation,
            description: response.description,
            run_by_roles: response.run_by_roles,
            roles: response.roles,
            relations: response.relations,
            createdDate: response.createdDate,
            modifiedDate: response.modifiedDate,
            report: response.report
        });
    }
}

